
    const data = {"name":"src/core/icons/account-filter","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M10 4c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4m7 17 1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3m-2-2.3-2.3-2.8c-.4-.5-.6-1.1-.6-1.7-.7-.2-1.4-.2-2.1-.2-4.4 0-8 1.8-8 4v2h13v-1.3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            